<template>
  <div class="ui form container">
    <h1 class="ui header" style="font-size: 35px;">
      Contact us
    </h1>
    <p style="font-size: 17px">
      We are very glad to hear your opinion or ideas or even if your Complaint about our website & we are here to answer all of your questions.<br>Just send what you want to say to us.
    </p>
    <div class="ui segment">
      <div class="fields">
        <div class="field" style="width: 50%">
          <label for="name">Name</label>
          <input type="text" placeholder="Name" v-model="contactUs.name" name="name">
        </div>

        <div class="field" style="width: 50%">
          <label for="name">E-mail</label>
          <input type="email" placeholder="E-mail" v-model="contactUs.email" name="email">
        </div>
      </div>

      <div class="field">
        <label>Your message</label>
        <textarea v-model="contactUs.message" name="message"></textarea>
      </div>

      <div class="ui submit blue button" @click="send()" :class="{ disabled: !formIsVaild }"
            style="background-color:#1d2537;">
          Send
      </div>

      <div class="ui error message"></div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      contactUs: {
        name: null,
        email: null,
        message: null
      },
      formIsVaild: false
    }
  },
  watch: {
    'contactUs': {
      handler: function () {
        this.formIsVaild = $('.ui.form').form('is valid')
      },
      deep: true
    }
  },
  mounted () {
    this.$nextTick(() => {
      $('.ui.form')
        .form({
          on: 'blur',
          fields: {
            name: 'empty',
            email: ['empty', 'email'],
            message: 'empty'
          }
        })
    })
  },
  methods: {
    send () {
    }
  }
}
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/components/landing-page/start_page_components/ContactUs.vue